<template>
    <table>
        <text-section v-for="(textSection, sectionIndex) in textSections"
            :content="textSection.content"
            :is-numbered="textSection.isNumbered"
            :key="'section-' + (sectionIndex + 1)">
        </text-section>
    </table>
</template>

<script>
export default {
  props: {
      text: { type: String, required: true }
  },

  computed: {
      textSections() {
        let rawText = JSON.parse(this.text);

        // Split the text by section, using the divs with the 'numberedlines' class as separator
        let textSections = rawText.split(/(<div class=\"numberedlines\"[^>]*>.+?<\/div>)/);

        // Filter out the empty sections (which could appear after and/or before a numbered section located at the very beginning or very end of the content),
        // then return an array of objects with the content of the section and boolean specifying if the section is numbered or not.
        return textSections.filter(textSection => textSection !== '').map(textSection => {
            let sectionIsNumbered = textSection.includes('numberedlines');
            return {
                'content': (sectionIsNumbered ? textSection.match(/(<div class=\"numberedlines\"[^>]*>.+?<\/div>)/)[1] : textSection),
                'isNumbered': sectionIsNumbered
            }
        });
      }
  }
}
</script>
